(() => {
  const SELECTOR = '[data-hh-bestsellers]';

  const init = (root) => {
    if (!root || root.dataset.hhBestsellersReady === 'true') return;
    root.dataset.hhBestsellersReady = 'true';

    const track = root.querySelector('[data-hh-bestsellers-track]');
    const progress = root.querySelector('[data-hh-bestsellers-progress]');
    const buttons = [...root.querySelectorAll('[data-hh-bestsellers-direction]')];

    if (!track) return;

    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

    const update = () => {
      const maximum = maxScroll();
      const position = Math.min(maximum, Math.max(0, track.scrollLeft));

      if (progress) {
        progress.style.width = `${maximum ? 18 + (position / maximum) * 82 : 100}%`;
      }

      buttons.forEach((button) => {
        const direction = Number(button.dataset.hhBestsellersDirection);
        button.disabled =
          maximum <= 2 ||
          (direction < 0 ? position <= 2 : position >= maximum - 2);
      });
    };

    const move = (direction) => {
      const items = [...track.querySelectorAll(':scope > .hh-bestsellers__item')];
      const maximum = maxScroll();

      if (maximum <= 2) return;

      let distance = Math.max(280, track.clientWidth * .62);

      if (items.length > 1) {
        const measured = Math.abs(items[1].offsetLeft - items[0].offsetLeft);
        if (measured > 0) distance = measured * 2;
      }

      track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      window.setTimeout(update, 380);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        move(Number(button.dataset.hhBestsellersDirection));
      });
    });

    track.addEventListener('scroll', update, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    }

    requestAnimationFrame(update);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(init);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
